export default () => ({
  error: '',
});
